var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"ncp_thead"},_vm._l((_vm.data),function(title,i){return _c('th',{key:i},[_vm._v(_vm._s(_vm.toI18n(title)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }